export const getLabel = (ary = [], value) => {
    const item = ary.find(function (item) {
        if(item.value === value){
            return true;
        }
        return false;
    });
    return item ? item.label : '';
}